/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { applePayGetMerchantDomains } from "../../funcs/applePayGetMerchantDomains.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApplePayMerchantDomainsRequest$inboundSchema,
};

export const tool$applePayGetMerchantDomains: ToolDefinition<typeof args> = {
  name: "apple-pay-get-merchant-domains",
  description: `Get domains registered with Apple Pay. 

Read our [Apple Pay tutorial](https://docs.moov.io/guides/sources/cards/apple-pay/#register-your-domains) to learn more. 

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/apple-pay.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await applePayGetMerchantDomains(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
